import { render, staticRenderFns } from "./Activitylist.vue?vue&type=template&id=1c1961fd&scoped=true&"
import script from "./Activitylist.vue?vue&type=script&lang=js&"
export * from "./Activitylist.vue?vue&type=script&lang=js&"
import style0 from "./Activitylist.vue?vue&type=style&index=0&id=1c1961fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1961fd",
  null
  
)

export default component.exports